/*******************************************************************
* PAGE        : UserForm
* REMARKS     :
* CREATED ON  : 09-09-2026
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 09-09-2026
********************************************************************/

import React, { useEffect, useState } from 'react';
import NotificationComponent from '../../components/NotificationComponent/NotificationComponent';
import { setEventMasterId } from '../../store/reduxMasterSlice';
import DialogComponent from '../../components/DialogComponent/DialogComponent';
import DropdownComponent from '../../components/DropdownComponent/DropdownComponent';
import { AddTicketUserMaster, getEventList } from '../../services/apiController';
import LoaderComponent from '../../components/LoaderComponent/LoaderComponent';
import RadioboxComponent from '../../components/RadioboxComponent/RadioboxComponent';
import InputComponent from '../../components/InputComponent/InputComponent';

// #region Component
const UserForm = ({ openPopup, selectedData = {}, handleClose }) => {

    // #region States
    // State to manage snackbar visibility and messages
    const [loading, setLoading] = useState(false);

    const [eventMasterData, setEventMasterData] = useState(false);

    const [errors, setErrors] = useState({}); // To store validation errors
    const [formData, setFormData] = useState({
        eventMasterId: selectedData?.TicketMasterId || 0,
        userName: selectedData?.UserName || '',
        userPassword: '',
        userIsActive: selectedData?.IsActive ?? true,
    });

    const [snackbarStates, setSnackbarStates] = useState({ isSnackbarOpen: false, snackbarMessage: '' });
    const handleCloseSnackbar = () => {
        setSnackbarStates({ isSnackbarOpen: false, snackbarMessage: '', snackbarSeverity: '' });
    };
    // #endregion

    useEffect(() => {
        wsGetEventList();
    }, [])

    const wsGetEventList = async () => {
        setLoading(true);
        getEventList({}).then((response) => {
            if (response) {
                const formattedData = (response.tickets || []).map(item => ({
                    ...item,
                    id: item.TicketMasterId,
                    value: item.EventName
                }));

                setEventMasterData(formattedData);
            } else {
                // Handle error scenario
            }
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            // Handle API error
        });
    }

    const wsAddTicketUserMaster = async () => {
        setLoading(true);

        const eventParameter = {
            "userName": formData.userName,
            "password": formData.userPassword,
            "ticketMasterId": formData.eventMasterId,
            "isActive": formData.userIsActive
        }

        AddTicketUserMaster(eventParameter)
            .then((response) => {
                if (response?.status) {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response?.message || "User create successfully", snackbarSeverity: "success" });
                } else {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response?.message || "Unable to save user", snackbarSeverity: "error" });
                }
                handleClose();
            }).catch((error) => {

            })
    }

    // #region Methods
    const handleChange = (e, type, maxLength) => {
        const { name, value } = e.target;

        setFormData((prev) => ({ ...prev, [name]: value }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: '' }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.eventMasterId) {
            newErrors.eventMasterId = "Please select event";
        }

        setErrors(newErrors);

        // Focus first error field
        const firstErrorField = Object.keys(newErrors)[0];

        if (firstErrorField) {
            const element = document.querySelector(`[name="${firstErrorField}"]`);
            if (element) {
                element.focus();
                element.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
        return Object.keys(newErrors).length === 0;
    }

    const handleSubmit = async () => {

        console.log('formData?.eventMasterId:', formData)

        if (!validateForm()) {
            return;
        }
        wsAddTicketUserMaster()
    }

    // #endregion

    return (loading ? <LoaderComponent />
        : <React.Fragment>
            <NotificationComponent isOpen={snackbarStates.isSnackbarOpen} message={snackbarStates.snackbarMessage} onClose={handleCloseSnackbar} severity={snackbarStates.snackbarSeverity} />
            <DialogComponent
                isOpen={openPopup}
                Title="User Add"
                maxWidth={'sm'}
                ActionText={"Save"}
                IsLoading={loading}
                onSave={handleSubmit}
                onClose={handleClose}
            >
                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ marginTop: '20px' }}>
                            <label>Select Event*</label>
                            <DropdownComponent name="eventMasterId" placeholder="Select Event*" value={formData.eventMasterId} onChange={handleChange} error={errors.eventMasterId} options={eventMasterData} />
                        </div>

                        <div style={{ marginTop: '20px' }}>
                            <label>User Name*</label>
                            <InputComponent name="userName" placeholder="User Name*" value={formData.userName} onChange={handleChange} error={errors.userName} maxLength={25} />
                        </div>

                        <div style={{ marginTop: '20px' }}>
                            <label>User Password*</label>
                            <InputComponent type="password" name="userPassword" placeholder="User Password" value={formData.userPassword} onChange={handleChange} error={errors.userPassword} maxLength={25} /><br />

                        </div>

                        <div style={{ marginTop: '20px', display: 'flex' }}>
                            <label style={{ width: '100%' }}>Is Active ?</label>

                            <RadioboxComponent
                                uniqueId="promo-yes"
                                name="userIsActive"
                                value="true"
                                checked={formData.userIsActive === true}
                                onChange={(e) => setFormData(prev => ({ ...prev, userIsActive: e.target.value === 'true' }))}
                                label={<label htmlFor="promo-yes" className="event-radio-card-label">
                                    <span className="event-radio-card-text">Yes</span>
                                </label>}
                            />

                            <RadioboxComponent
                                uniqueId="promo-no"
                                name="userIsActive"
                                value="false"
                                checked={formData.userIsActive === false}
                                onChange={(e) => setFormData(prev => ({ ...prev, userIsActive: e.target.value === 'true' }))}
                                label={<label htmlFor="promo-no" className="event-radio-card-label">
                                    <span className="event-radio-card-text">No</span>
                                </label>}
                            />
                        </div>

                    </div>
                </form>
            </DialogComponent>
        </React.Fragment>
    );
};
// #endregion

export default UserForm;